import React, { FC } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { Link as RouterLink } from 'react-router-dom'
import { Link } from '@mui/material'
import {
	PAGE_COACHES,
	PAGE_USERS,
} from '../../../../../../constants/navigation'
import { useTypedSelector } from '../../../../../../hooks/useTypedSelector'
import { selectSelectedCoachName } from '../../../../../../store/reducers/coaches/selectors'
import { history } from '../../../../../../store'

const CoachOverviewHeadCrumbs: FC = () => {
	const coachName = useTypedSelector(selectSelectedCoachName)
	const fromUsers = history.location.state === 'users'
	return (
		<Box
			component={'ul'}
			m={0}
			p={0}
			sx={{ listStyleType: 'none' }}
			display={'flex'}
			alignItems={'center'}
		>
			<Box
				component={'li'}
				display={'flex'}
				style={{ lineHeight: 'normal' }}
				mr={1}
			>
				<Link
					to={fromUsers ? PAGE_USERS : PAGE_COACHES}
					component={RouterLink}
					color={'primary'}
					maxWidth={'11rem'}
					sx={{ fontFamily: 'Gilroy-Medium, sans-serif' }}
					lineHeight={'normal'}
				>
					{fromUsers ? 'Users' : 'Coaches'}
				</Link>

				<Typography ml={1}> {'>'} </Typography>
			</Box>

			<Box
				component={'li'}
				display={'flex'}
				style={{ lineHeight: 'normal' }}
			>
				<Typography
					fontFamily={'Gilroy-Medium, sans-serif'}
					color={'primary'}
					mb={0.8}
					maxWidth={'11rem'}
				>
					{coachName}
				</Typography>
			</Box>
		</Box>
	)
}

export default CoachOverviewHeadCrumbs
